/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveDeviceRequest
 */
export interface RemoveDeviceRequest {
    /**
     * FCM device token to remove
     * @type {string}
     * @memberof RemoveDeviceRequest
     */
    fcmToken: string;
}

/**
 * Check if a given object implements the RemoveDeviceRequest interface.
 */
export function instanceOfRemoveDeviceRequest(value: object): value is RemoveDeviceRequest {
    if (!('fcmToken' in value) || value['fcmToken'] === undefined) return false;
    return true;
}

export function RemoveDeviceRequestFromJSON(json: any): RemoveDeviceRequest {
    return RemoveDeviceRequestFromJSONTyped(json, false);
}

export function RemoveDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fcmToken': json['fcmToken'],
    };
}

export function RemoveDeviceRequestToJSON(json: any): RemoveDeviceRequest {
    return RemoveDeviceRequestToJSONTyped(json, false);
}

export function RemoveDeviceRequestToJSONTyped(value?: RemoveDeviceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fcmToken': value['fcmToken'],
    };
}

